import { render, staticRenderFns } from "./TransactionBill.vue?vue&type=template&id=e612fb9c&"
import script from "./TransactionBill.vue?vue&type=script&lang=js&"
export * from "./TransactionBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports